import {
  BackArrowButton,
  CancelButton,
  CloseButton,
  FinishButton,
} from "../../../fixedassetelements/button/Button";

import commonstyles from "../Forms.module.css";
import styles from "./PayableUploadedfile.module.css";

import addIcon from "../../../assets/icons/addEcl.svg";
import removeIcon from "../../../assets/icons/removeLoansIcons.svg";
import refreshIcon from "../../../assets/icons/repeatIcon.svg";
import circleCheck from "../../../assets/icons/circle_check.svg";

function PayableUploadedFile({
  onBack,
  onClose,
  onStartMapping,
  uploadedFiles = [],
  onRemove,
  onAdd,
  onFinish,
  canFinish = false,
}) {
  const files = uploadedFiles ?? [];

  return (
    <div className={commonstyles.backdrop}>
      <div className={`${commonstyles.container} ${styles.smallContainer}`}>
        <div className={`${commonstyles.header} ${commonstyles.headerLarge}`}>
          <div className={commonstyles.headerLeft}>
            <BackArrowButton onClick={onBack} />
            <h2 className={commonstyles.heading}>
              Payable Register – Uploaded Files
            </h2>
          </div>
          <CloseButton onClick={onClose} />
        </div>

        <div className={styles.upperText}>
         <h5 className={styles.filesUpload}>
            {files.length === 0
              ? "No files uploaded"
              : `${files.length} ${files.length === 1 ? "file" : "files"} uploaded`}
          </h5>
          <button className={styles.addButton} onClick={onAdd}>
            <img src={addIcon} alt="add icon" />
            Add Files
          </button>
        </div>

        <div className={styles.fileList}>
          {files.map((file, index) => (
            <div className={styles.fileRow} key={index}>
              <div className={styles.leftSide}>
                <span className={styles.fileName}>
                  {file.displayName || file.name || file.fileName || file.originalname || file.rawFile?.name || "Untitled file"}
                </span>

                <button
                  className={styles.removeBtn}
                  onClick={() => onRemove?.(index)}
                >
                  <img src={removeIcon} alt="remove" />
                </button>
              </div>

              <div className={styles.mappingRight}>
                {file.isMapped ? (
                  <span className={styles.mapped}>
                    <img src={circleCheck} alt="check" className={styles.checkIcon} />
                    Mapped
                    <span className={styles.refreshWrapper}>
                      <img src={refreshIcon} alt="refresh" />
                    </span>
                  </span>
                ) : (
                  <button
                    className={styles.startMapping}
                    onClick={() => onStartMapping(index)}
                  >
                    Start Mapping
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className={styles.footer}>
          <CancelButton onClick={onClose} />
          <FinishButton onClick={onFinish} isEnabled={canFinish} />
        </div>
      </div>
    </div>
  );
}

export default PayableUploadedFile;
